import React from "react";
import CommonLayout from "./CommonLayout";
import { Tab } from "@headlessui/react";
import MyWallet from "containers/Wallet/myWallet";
import { AuthContext } from "context/userContext";
import { useContext } from "react";

const DirecConnects = () => {
  const authContext = useContext(AuthContext);
  const { ownerData } = authContext;
  return (
    <div className="flex w-screen">
      <CommonLayout>
        <div
          className="nc-AccountPage flex  flex-grow w-full container "
          data-nc-id="AccountPage"
        >

<div className="space-y-6 sm:space-y-8 flex flex-grow flex-col">
          <div>
            <Tab.Group>
              <Tab.Panels>
                <Tab.Panel className="">
                  <MyWallet
                    ownerId={ownerData._id}
                    direcCoins_wallet={ownerData.direcCoins_wallet}
                    ownerData={ownerData}
                  />
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>        </div>
      </CommonLayout>
    </div>
  );
};

export default DirecConnects;
